module.exports = __webpack_public_path__ + "img/4_hillstate.dfef96b3.png";